// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1gHOc","log":"ModalInventoryLogs_log__vYHPO","date":"ModalInventoryLogs_date__1LY-x","userName":"ModalInventoryLogs_userName__1qjh8"};